<template>
  <div>
    <t-form label-width="80px">
      <CptData :data="props.attribute.cptTableData" :cptDataForm="props.cptDataForm" />
      <e-collapse title="地图配置" :expand="true">
        <t-form-item label="地图缩放级别">
          <t-input-number v-model="props.attribute.zoom" :min="3" size="large" :decimal-places="0" />
        </t-form-item>
        <t-form-item label="中心坐标X轴">
          <t-input-number v-model="props.attribute.centerx" :step="0.000001" size="large" :decimal-places="6" />
        </t-form-item>
        <t-form-item label="中心坐标y轴">
          <t-input-number v-model="props.attribute.centery" :step="0.000001" size="large" :decimal-places="6" />
        </t-form-item>
        <!-- <t-form-item label="地图样式地址">
          <t-textarea v-model="props.attribute.tareaValue" placeholder="请输入内容" />
        </t-form-item> -->
        <!-- <t-form-item label="">
          <t-link href="https://api.map.baidu.com/">自定义地图平台</t-link>
        </t-form-item> -->
        <t-form-item label="图库选择">
          <div @click="showGallery" style="width: 168px; height: 160px">
            <t-image style="width: 50%; height: 50%;  background: none" :src="attribute.url? fileUrl + attribute.url: require('@/assets/logo.png') " fit="fill" />
          </div>
        </t-form-item>
        <t-form-item label="图片宽度">
              <t-input-number
                size="small"
                :min="0"
                :max="9999"
                v-model="props.attribute.width"
                :decimal-places="0"
              />
      </t-form-item>
      <t-form-item label="图片高度">
        <t-input-number
          size="small"
          :min="0"
          :max="9999"
          v-model="props.attribute.height"
          :decimal-places="0"
        />
      </t-form-item>
      <t-form-item label="轨迹线颜色">
          <t-color-picker
            size="small"
            :colorModes="['monochrome']"
            format="RGBA"
            enableAlpha
            v-model="props.attribute.strokeColor"
          />
      </t-form-item>
      <t-form-item label="轨迹线类型">
        <t-select v-model="props.attribute.strokeStyle">
          <t-option key="solid" label="solid" value="solid" />
          <t-option key="dashed" value="dashed">dashed</t-option>
        </t-select>
      </t-form-item>
      <t-form-item label="轨迹线粗细">
        <t-input-number
          size="small"
          :min="0"
          :max="10"
          v-model="props.attribute.strokeWeight"
          :decimal-places="0"
        />
      </t-form-item>
        <t-form-item label="轨迹动画速度(ms)">
        <t-input-number
          size="small"
          :min="1000"
          :step="5000"
          :max="100000"
          v-model="props.attribute.duration"
          :decimal-places="0"
        />
      </t-form-item>
          <t-form-item label="漫游">
      <t-switch v-model="props.attribute.trackAni"  :label="['开', '关']" size="small"/>
    </t-form-item>
      </e-collapse>
    </t-form>
    <Gallery ref="gallery" @confirmCheck="confirmCheck" />
  </div>
</template>

<script setup>
import env from "/env";
import { ref } from "vue";
import Gallery from "@/components/designer/gallery";
import CptData from "@/components/element/options/comp/cpt-data";

let gallery = ref(null);
let fileUrl = ref(env.fileUrl);

let props = defineProps({
  attribute: Object,
  cptDataForm: Object,
  currentCpt: Object,
});
let showGallery = () => {
  gallery.value.opened();
};

let confirmCheck = (url) => {
  props.attribute.url = url;
};
</script>